/* eslint-disable no-console */
export const urls = {
    data: function () {
        return {
            fetchUrl:'https://demo.seasideworkshop.net' //  'https://demo.seasideworkshop.net' 'http://localhost:10086'
        }
    },
}